import { githubBot } from "./articles/githubBot";
import { greenmask } from "./articles/greenmask";
import { scaling_rds } from "./articles/scaling_rds";
import { texResume } from "./articles/texResume";
import { tf_module_ci } from "./articles/tf_module_ci";

const myArticles = [githubBot, texResume, greenmask, tf_module_ci, scaling_rds];

export default myArticles;
